import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { authColors, brandGradient, fontStack } from './authStyles';
import BrandLogo from './BrandLogo';

// Mise en page deux panneaux de la maquette F1 :
// - panneau de marque à gauche (dégradé vert, masqué sur mobile)
// - zone de formulaire à droite, centrée
const AuthLayout = ({
  brandTitle,
  brandSubtitle,
  error,
  success,
  maxWidth = 460,
  onBack,
  children,
}) => {
  return (
   <Box
  sx={{
    height: '100dvh',
    minHeight: '100dvh',
    maxHeight: '100dvh',
    width: '100%',
    display: 'flex',
    overflow: 'hidden',
    backgroundColor: '#1a1b2e',
    fontFamily: fontStack,
  }}
>
      {/* Panneau de marque */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: 480,
          flexShrink: 0,
          p: '48px',
          background: brandGradient,
        }}
      >
        <BrandLogo />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <Typography
            sx={{
              color: authColors.accentGreen,
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '2.4px',
            }}
          >
            PLATEFORME DE SUPERVISION
          </Typography>
          <Typography
            sx={{
              color: authColors.textPrimary,
              fontSize: '34px',
              fontWeight: 700,
              lineHeight: 1.15,
              maxWidth: 380,
            }}
          >
            {brandTitle}
          </Typography>
          <Typography
            sx={{
              color: authColors.textMuted,
              fontSize: '14px',
              lineHeight: 1.6,
              maxWidth: 384,
            }}
          >
            {brandSubtitle}
          </Typography>
        </Box>

        <Typography sx={{ color: authColors.textMuted, fontSize: '12px' }}>
          © 2026 Ecowatch 360
        </Typography>
      </Box>

      {/* Zone formulaire */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: { xs: 'flex-start', md: 'center' },
          alignItems: 'center',
          p: { xs: '32px 20px', md: '48px' },
        }}
      >
        <Box sx={{ width: '100%', maxWidth }}>
          {/* Retour vers l'accueil, uniquement sur mobile */}
          {onBack && (
            <Box
              component="button"
              type="button"
              onClick={onBack}
              sx={{
                display: { xs: 'inline-flex', md: 'none' },
                alignItems: 'center',
                gap: '6px',
                mb: '20px',
                p: 0,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: authColors.textMuted,
                fontFamily: fontStack,
                fontSize: '13px',
                fontWeight: 500,
                '&:hover': { color: authColors.textPrimary },
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              Accueil
            </Box>
          )}

          {/* Logo affiché uniquement sur mobile (le panneau de marque est masqué) */}
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              justifyContent: 'center',
              mb: '28px',
            }}
          >
            <BrandLogo vertical />
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: '20px', borderRadius: '12px' }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: '20px', borderRadius: '12px' }}>
              {success}
            </Alert>
          )}
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
